import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Headercomponent from "./Headercomponent";
import Searchcomponent from "./Searchcomponent"; // Added missing import

const HomePage = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const [userName, setUserName] = useState("");
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [featuredCategories, setFeaturedCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchResults, setSearchResults] = useState([]); // Added state
  const [error, setError] = useState(null); // Added state

  useEffect(() => {
    const user = { name: "" };
    setUserName(user.name);
    
    const initialCategories = [
      { id: '1', name: 'Allergies', path: '/allergies', icon: '🌸', color: '#4ADE80' },
      { id: '2', name: 'Analgesics', path: '/analgesics', icon: '💊', color: '#F87171' },
      { id: '3', name: 'Anti-Infectives', path: '/antiinfectives', icon: '🛡️', color: '#60A5FA' },
      { id: '4', name: 'Anti-malaria', path: '/antimalaria', icon: '🦟', color: '#FBBF24' },
      { id: '5', name: 'Cardio', path: '/cardio', icon: '❤️', color: '#F472B6' },
      { id: '6', name: 'Consumables', path: '/consumables', icon: '🩹', color: '#A78BFA' },
      { id: '7', name: 'Contraceptives', path: '/contraceptives', icon: '⚪', color: '#FB7185' },
      { id: '8', name: 'Cough', path: '/cough', icon: '🫁', color: '#38BDF8' },
      { id: '9', name: 'Creams', path: '/creams', icon: '🧴', color: '#34D399' },
      { id: '10', name: 'Diabetics', path: '/diabetics', icon: '💉', color: '#F59E0B' },
      { id: '11', name: 'Eye', path: '/eye', icon: '👁️', color: '#6366F1' },
      { id: '12', name: 'Gastro', path: '/gastro', icon: '🧬', color: '#EC4899' },
      { id: '13', name: 'Haematinics', path: '/haematinics', icon: '💧', color: '#14B8A6' },
      { id: '14', name: 'Multivitamins', path: '/multivitamins', icon: '🌿', color: '#8B5CF6' },
      { id: '15', name: 'Paediatrics', path: '/paediatrics', icon: '👶', color: '#F97316' },
      { id: '16', name: 'Supplements', path: '/supplements', icon: '💪', color: '#06B6D4' },
    ];
    
    setCategories(initialCategories);
    
    const shuffled = [...initialCategories].sort(() => 0.5 - Math.random());
    setFeaturedCategories(shuffled.slice(0, 4));
  }, []);

  // Added missing function stubs
  const debouncedFetchProducts = (query) => {
    console.log("Searching for:", query);
    // Implement your search logic here
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setSearchResults([]);
  };

  const handleProductClick = (product) => {
    console.log("Product clicked:", product);
    // Navigate to product details
  };

  const handleCategoryPress = (category) => {
    navigate(category.path);
  };

  const handleSearchPress = () => {
    setSearchActive(true);
  };

  const handleBack = () => {
    setSearchActive(false);
    setSearchQuery('');
  };

  const toggleAllCategories = () => {
    setShowAllCategories(!showAllCategories);
  };

  const renderCategoryItem = (category) => (
    <div 
      key={category.id}
      onClick={() => handleCategoryPress(category)}
      className="category-item"
      style={{ '--category-color': category.color }}
    >
      <div 
        className="category-icon"
        style={{ backgroundColor: category.color }}
      >
        {category.icon}
      </div>
      <span className="category-name">{category.name}</span>
    </div>
  );

  return (
    <div className="pharmacy-app">
      {/* Background Gradient */}
      <div className="app-background"></div>
      
      <Headercomponent />
      
      <div className="app-content">
        {!searchActive ? (
          <div className="home-content">
            {/* Welcome Section */}
            <div className="welcome-section">
              <div>
                <h2 className="welcome-text">
                  {userName ? `Hello, ${userName}` : 'Welcome to Lihen Pharmacy'}
                </h2>
                <p className="welcome-subtext">
                  What would you like to order today?
                </p>
              </div>
            </div>
            
            {/* Search Bar - Replaced with SearchComponent */}
            <Searchcomponent
              onSearch={debouncedFetchProducts}
              onClear={handleClearSearch}
              error={error}
              searchResults={searchResults}
              onProductClick={handleProductClick}
            />

            {/* Featured Categories */}
            <div className="section">
              <div className="section-header">
                <h3 className="section-title">Featured Categories</h3>
                <button 
                  onClick={() => {
                    const shuffled = [...categories].sort(() => 0.5 - Math.random());
                    setFeaturedCategories(shuffled.slice(0, 4));
                  }}
                  className="shuffle-button"
                  aria-label="Shuffle categories"
                >
                  <span className="shuffle-icon">🔀</span>
                </button>
              </div>
              
              <div className="featured-categories">
                {featuredCategories.map(category => (
                  <div 
                    key={category.id}
                    onClick={() => handleCategoryPress(category)}
                    className="featured-category-item"
                    style={{ '--category-color': category.color }}
                  >
                    <div 
                      className="featured-category-content"
                      style={{ backgroundColor: category.color }}
                    >
                      <div className="category-icon-large">{category.icon}</div>
                      <span className="category-name-large">{category.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Browse Categories */}
            <div className="section">
              <div className="section-header">
                <h3 className="section-title">Browse Categories</h3>
                <button onClick={toggleAllCategories} className="view-all-button">
                  View All
                </button>
              </div>
              
              <div className="categories-grid">
                {categories.slice(0, 8).map(category => renderCategoryItem(category))}
              </div>
            </div>

            {/* Health Tips Banner */}
            <div className="health-tips-banner">
              <div className="health-tips-content">
                <div className="health-tips-text">
                  <h3 className="health-tips-title">Health Tips</h3>
                  <p className="health极ips-subtitle">Expert advice for your wellbeing</p>
                </div>
                <div className="health-tips-icon">
                  <span className="heart-icon">❤️</span>
                </div>
              </div>
            </div>

            {/* Stats Container */}
            <div className="stats-container">
              <div className="stat-item">
                <span className="stat-icon">💊</span>
                <p className="stat-number">1000+</p>
                <p className="stat-label">Products</p>
              </div>
              
              <div className="stat-divider"></div>
              
              <div className="stat-item">
                <span className="stat-icon">👥</span>
                <p className="stat-number">10K+</p>
                <p className="stat-label">Customers</p>
              </div>
              
              <div className="stat-divider"></div>
              
              <div className="stat-item">
                <span className="stat-icon">⭐</span>
                <p className="stat-number">4.8</p>
                <p className="stat-label">Rating</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="search-content">
            <div className="search-header">
              <button onClick={handleBack} className="back-button" aria-label="Go back">
                <span className="back-icon">←</span>
              </button>
              <div className="search-input-container">
                <span className="search-input-icon">🔍</span>
                <input
                  type="text"
                  placeholder="Search medications..."
                  className="search-input"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  autoFocus
                />
                {searchQuery && (
                  <button onClick={() => setSearchQuery('')} className="clear-button" aria-label="Clear search">
                    <span className="clear-icon">×</span>
                  </button>
                )}
              </div>
            </div>
            
            {searchQuery ? (
              <div className="search-results">
                <div className="no-results">
                  <span className="no-results-icon">🔍</span>
                  <h3 className="no-results-title">No results found</h3>
                  <p className="no-results-text">Try different keywords or browse categories</p>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>

      {/* All Categories Modal */}
      {showAllCategories && (
        <div className="modal-overlay" onClick={toggleAllCategories}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">All Categories</h3>
              <button onClick={toggleAllCategories} className="modal-close-button" aria-label="Close modal">
                <span className="modal-close-icon">×</span>
              </button>
            </div>
            
            <div className="modal-categories">
              <div className="categories-grid-modal">
                {categories.map(category => renderCategoryItem(category))}
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .pharmacy-app {
          min-height: 100vh;
          position: relative;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
        }
        
        .app-background {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #f8fafc 0%, #f0fdf4 50%, #ecfdf5 100%);
          z-index: -1;
        }
        
        .app-content {
          padding: 24px 5%;
          max-width: 1400px;
          margin: 0 auto;
        }
        
        .welcome-section {
          margin-bottom: 24px;
          text-align: center;
        }
        
        .welcome-text {
          font-size: 32px;
          font-weight: 700;
          color: #1f2937;
          margin: 0 0 8px 0;
        }
        
        .welcome-subtext {
          font-size: 18px;
          color: #6b7280;
          margin: 0;
        }
        
        .section {
          margin-bottom: 40px;
        }
        
        .section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
        }
        
        .section-title {
          font-size: 24px;
          font-weight: 700;
          color: #1f2937;
          margin: 0;
        }
        
        .shuffle-button {
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: background-color 0.2s;
        }
        
        .shuffle-button:hover {
          background-color: #f3f4f6;
        }
        
        .view-all-button {
          background: none;
          border: none;
          color: #4ade80;
          font-weight: 600;
          font-size: 16px;
          cursor: pointer;
          padding: 8px 12px;
          border-radius: 8px;
          transition: background-color 0.2s;
        }
        
        .view-all-button:hover {
          background-color: #f0f极4;
        }
        
        .featured-categories {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
        }
        
        .featured-category-item {
          height: 160极;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        
        .featured-category-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
        }
        
        .featured-category-content {
          width: 100%;
          height: 100%;
          padding: 24px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        
        .category-icon-large {
          font-size: 40px;
          margin-bottom: 12px;
          color: white;
        }
        
        .category-name-large {
          font-size: 18px;
          font-weight: 700;
          color: white;
          text-align: center;
        }
        
        .categories-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          gap: 20px;
        }
        
        .category-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          transition: transform 0.2s;
        }
        
        .category-item:hover {
          transform: translateY(-4px);
        }
        
        .category-icon {
          width: 70px;
          height: 70px;
          border-radius: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28px;
          color: white;
          margin-bottom: 12px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
          transition: transform 0.2s;
        }
        
        .category-item:hover .category-icon {
          transform: scale(1.05);
        }
        
        .category-name {
          font-size: 14px;
          font-weight: 600;
          color: #374151;
          text-align: center;
        }
        
        .health-tips-banner {
          background: linear-gradient(to right, #6366f1, #8b5cf6);
          border-radius: 20px;
          padding: 28px;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
          margin-bottom: 40px;
          transition: transform 0.3s;
        }
        
        .health-tips-banner:hover {
          transform: translateY(-2px);
        }
        
        .health-tips-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .health-tips-text {
          flex: 1;
        }
        
        .health-tips-title {
          font-size: 22px;
          font-weight: 700;
          color: white;
          margin: 0 0 8px 0;
        }
        
        .health-tips-subtitle {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.9);
          margin: 0;
        }
        
        .health-tips-icon {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          width: 60px;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28px;
          transition: transform 0.2s;
        }
        
        .health-tips-icon:hover {
          transform: scale(1.1);
        }
        
        .stats-container {
          background: white;
          border-radius: 20px;
          padding: 32px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-shadow: 极 6px 16px rgba(0, 0, 0, 0.08);
          margin: 0 auto;
          max-width: 800px;
        }
        
        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
          padding: 0 20px;
        }
        
        .stat-icon {
          font-size: 28px;
          margin-bottom: 12px;
        }
        
        .stat-number {
          font-size: 24px;
          font-weight: 700;
          color: #1f2937;
          margin: 0 0 8px 0;
        }
        
        .stat-label {
          font-size: 14px;
          color: #6b7280;
          margin: 0;
          font-weight: 500;
        }
        
        .stat-divider {
          width: 1px;
          height: 60px;
          background: #f3f4f6;
        }
        
        /* Search View Styles */
        .search-content {
          background: white;
          min-height: 100vh;
        }
        
        .search-header {
          display: flex;
          align-items: center;
          padding: 20px 5%;
          border-bottom: 1px solid #e5e7eb;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .back-button {
          background: none;
          border: none;
          font-size: 24px;
          margin-right: 16px;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: background-color 0.2s;
        }
        
        .back-button:hover {
          background-color: #f3f4f6;
        }
        
        .search-input-container {
          flex: 1;
          display: flex;
          align-items: center;
          background: #f9fafb;
          border-radius: 14px;
          padding: 0 16px;
          height: 56px;
          transition: background-color 0.2s;
        }
        
        .search-input-container:focus-within {
          background: white;
          box-shadow: 0 0 0 2px #4ade80;
        }
        
        .search-input-icon {
          margin-right: 12px;
          color: #9ca3af;
          font-size: 20px;
        }
        
        .search-input {
          flex: 1;
          background: none;
          border: none;
          height: 56px;
          font-size: 16px;
          color: #374151;
          outline: none;
        }
        
        .clear-button {
          background: none;
          border: none;
          font-size: 20px;
          color: #9ca3af;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: background-color 0.2s;
        }
        
        .clear-button:hover {
          background-color: #f3f4f6;
        }
        
        .search-results {
          padding: 60px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        
        .no-results {
          text-align: center;
          max-width: 400px;
        }
        
        .no极ults-icon {
          font-size: 80px;
          color: #e5e7eb;
          display: block;
          margin-bottom: 24px;
        }
        
        .no-results-title {
          font-size: 22px;
          font-weight: 600;
          color: #374151;
          margin: 0 0 12px 0;
        }
        
        .no-results-text {
          font-size: 16px;
          color: #6b7280;
          margin: 0;
          line-height: 1.5;
        }
        
        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }
        
        .modal-content {
          background: white;
          border-radius: 20px;
          width: 100%;
          max-width: 900px;
          max-height: 80vh;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
        }
        
        .modal-header {
          display:flex;
          justify-content: space-between;
          align-items: center;
          padding: 24px 32px;
          border-bottom: 1px solid #f3f4f6;
        }
        
        .modal-title {
          font-size: 24px;
          font-weight: 700;
          color: #1f2937;
          margin: 0;
        }
        
        .modal-close-button {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: background-color 0.2s;
        }
        
        .modal-close-button:hover {
          background-color: #f3f4f6;
        }
        
        .modal-categories {
          padding: 24px;
          overflow-y: auto;
          max-height: calc(80vh - 100px);
          padding-bottom: 40px;
        }
        
        .categories-grid-modal {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
          gap: 20px;
        }
        
        /* Mobile Responsive Styles for Featured Categories */
        @media (max-width: 1024px) {
          .app-content {
            padding: 20px;
          }
          
          .welcome-text {
            font-size: 28px;
          }
          
          .featured-categories {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        @media (max-width: 768px) {
          .welcome-text {
            font-size: 24px;
          }
          
          .welcome-subtext {
            font-size: 16px;
          }
          
          .section-title {
            font-size: 20px;
          }
          
          .featured-categories {
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
          }
          
          .featured-category-item {
            height: 140px;
            border-radius: 16px;
          }
          
          .featured-category-content {
            padding: 16px;
          }
          
          .category-icon-large {
            font-size: 32px;
            margin-bottom: 8px;
          }
          
          .category-name-large {
            font-size: 16px;
          }
          
          .categories-grid {
            grid-template-columns: repeat(4, 1fr);
          }
          
          .stats-container {
            flex-direction: column;
            gap: 20px;
          }
          
          .stat-divider {
            width: 100%;
            height: 1px;
          }
        }
        
        @media (max-width: 640px) {
          .featured-categories {
            grid-template-columns: 1fr;
            gap: 12px;
          }
          
          .featured-category-item {
            height: 120px;
          }
          
          .categories-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .categories-grid-modal {
            grid-template-columns: repeat(3, 1fr);
          }
          
          .health-tips-content {
            flex-direction: column;
            text-align: center;
            gap: 16px;
          }
          
          .search-header {
            padding: 16px 4%;
          }
        }
        
        @media (max-width: 480px) {
          .featured-categories {
            grid-template-columns: 1fr;
          }
          
          .featured-category-item {
            height: 110px;
            border-radius: 14px;
          }
          
          .featured-category-content {
            padding: 12px;
          }
          
          .category-icon-large {
            font-size: 28px;
          }
          
          .category-name-large {
            font-size: 14px;
          }
          
          .categories-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
          }
          
          .categories-grid-modal {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .stat-item {
            padding: 0 10px;
          }
          
          .category-icon {
            width: 60px;
            height: 60px;
            font-size: 24px;
          }
          
          .category-name {
            font-size: 12px;
          }
        }
        
        @media (max-width: 360px) {
          .featured-category-item {
            height: 100px;
          }
          
          .category-icon-large {
            font-size: 24px;
          }
          
          .category-name-large {
            font-size: 12px;
          }
          
          .categories-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default HomePage;